import React, {Fragment,Component} from "react";
import axios from "axios";
import exportToExcel from "../utils/ExcelUtils";

class HDBFYPRow extends Component{
    constructor(props) {
        super(props);
        this.state = {
            errorMessage: '',
            apiDetail: '/api/bankportal/report/detail/fyp/hdb/directsale',
            reportName: 'HDB_ReportFYP',
        }
        this.onCLickToExport = this.onCLickToExport.bind(this);
        this.exportToExcel = exportToExcel.bind(this);
        this.handlerClickNode = this.props.handlerClickNode.bind(this);
        this.handlerSetIsLoading = this.props.handlerSetIsLoading.bind(this);
    }

    componentDidMount() {

    }
    onCLickToExport = (item) => {
        const payload = {
            yyyymmdd: item?.yyyymmdd,
            code: item?.code,
            type: item?.type,
            parentId: item?.parentId
        }
        /*
        const headers = {
            'Authorization': 'Bearer my-token',
            'Access-Control-Allow-Origin': true,
            'My-Custom-Header': 'foobar'
        };

         */
        const { apiDetail, reportName } = this.state;
        this.handlerSetIsLoading(true);
        axios.post(apiDetail, payload)
            .then(response => {
                let data = [];
                if(!!response.data){
                    data.push([
                        "Ngày báo cáo"
                        ,"Mã chi nhánh (Ngân hàng)"
                        ,"Tên chi nhánh"
                        ,"Mã phòng giao dịch (Ngân hàng)"
                        ,"Tên phòng giao dịch"
                        ,"Mã NVNH"
                        ,"Tên NVNH"
                        ,"Số hợp đồng"
                        ,"Tên khách hàng"
                        ,"FYP thực thu"
                        ,"Phí kỳ đầu tiên"
                        ,"Kỳ đóng phí"
                        ,"Ngày nộp"
                        ,"Ngày phát hành"
                        ,"Mã sản phẩm"
                        ,"Tên sản phẩm"
                        ,"Tình trạng hợp đồng"
                        ,"Tên tình trạng hợp đồng"
                        ,"Loại sản phẩm"
                        ,"Ngày ký nhận thư"
                        ,"Ngày ACK + 21"
                        ,"Mã miền"
                        ,"Tên miền"
                    ]);
                    response?.data.map(item =>
                        data.push([
                            item?.reportDate
                            ,item?.boCodeBank
                            ,item?.boName
                            ,item?.toCodeBank
                            ,item?.toName
                            ,item?.fscCode
                            ,item?.fscName
                            ,item?.policyNumber
                            ,item?.poName
                            ,item?.fyp
                            ,item?.ip
                            ,item?.premiumMode
                            ,item?.submitDate
                            ,item?.firstIssueDate
                            ,item?.productCode
                            ,item?.productName
                            ,item?.statusCode
                            ,item?.statusName
                            ,item?.productType
                            ,item?.ackDate
                            ,item?.passAckDate
                            ,item?.regionCode
                            ,item?.regionName
                        ])
                    )
                }

                const exportName = item?.yyyymmdd+'_'+item?.code+'_'+item?.name+'_'+reportName;
                this.exportToExcel(data, exportName);
                this.handlerSetIsLoading(false);
            })
            .catch(error => {
                this.setState({ errorMessage: error.message });
                console.error('There was an error!', error);
                this.handlerSetIsLoading(false);
            });
    }
    render() {
        const {hasChild,isExpanded,marginLeftValue,data} = this.props;
        const iconStyle = {
            marginLeft: marginLeftValue+'px',
            boxShadow: 'none'
        }
        return (
            <Fragment>
            {
                !!data &&
                    <tr>
                        <td className={'bp-report-tree-node'}>
                            <button style={iconStyle} type="button" className={"btn"} onClick={this.handlerClickNode}>
                                {
                                    hasChild ?isExpanded?(' - '):(' + '):('   ')
                                }
                            </button>
                            <span>{ data?.name }</span>
                        </td>
                        <td className={"bp-report-td"}><span> { data?.c_issued?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.fyp_issued?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.c_issued_mtd?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.fyp_issued_mtd?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.c_issued_ytd?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.fyp_issued_ytd?.toLocaleString() } </span></td>
                    </tr>

            }
            </Fragment>
        )
    }
}
export default HDBFYPRow;